import Flex from 'typescript-styled-flex'
import styled, { ITheme } from '../../../theme'
import { IWithSize } from '../../../containers/BookingCalendar/Calendar/Calendar'

const IconWrapper = styled(Flex as any)<IWithSize>`
  position: absolute;
  right: ${({ size }) => (size ? 10 * size : 10)}px;
  cursor: pointer;
  width: ${({ size }) => (size ? 30 * size : 30)}px;
  height: ${({ size }) => (size ? 30 * size : 30)}px;
  border-radius: 50%;

  &:hover {
    background-color: ${(props: ITheme) => props.theme.colors.palette.paleGrey};
  }
`

export default IconWrapper
